import { ExternalEscalationType } from '..';
import { RandomGenerator } from "../../../test-utils";
import { EscalationType } from "./escalation-type.enum";
var TicketEscalationBuilder = /** @class */ (function () {
    function TicketEscalationBuilder() {
        this.ticketEscalation = {
            id: RandomGenerator.id(),
            internalReplyId: RandomGenerator.id(),
            performingUser: RandomGenerator.agent(),
            type: EscalationType.EXTERNAL,
            escalationId: RandomGenerator.id(),
            creationDate: Date.now(),
            externalEscalationType: ExternalEscalationType.CALLBACK,
            externalProviderId: RandomGenerator.id()
        };
    }
    TicketEscalationBuilder.prototype.withExternalProviderId = function (externalProviderId) {
        this.ticketEscalation.externalProviderId = externalProviderId;
        return this;
    };
    TicketEscalationBuilder.prototype.withId = function (id) {
        this.ticketEscalation.id = id;
        return this;
    };
    TicketEscalationBuilder.prototype.withInternalReplyId = function (internalReplyId) {
        this.ticketEscalation.internalReplyId = internalReplyId;
        return this;
    };
    TicketEscalationBuilder.prototype.withPerformingUser = function (performingUser) {
        this.ticketEscalation.performingUser = performingUser;
        return this;
    };
    TicketEscalationBuilder.prototype.withType = function (type) {
        this.ticketEscalation.type = type;
        return this;
    };
    TicketEscalationBuilder.prototype.withEscalationId = function (escalationId) {
        this.ticketEscalation.escalationId = escalationId;
        return this;
    };
    TicketEscalationBuilder.prototype.withCreationDate = function (creationDate) {
        this.ticketEscalation.creationDate = creationDate;
        return this;
    };
    TicketEscalationBuilder.prototype.withExternalEscalationType = function (externalEscalationType) {
        this.ticketEscalation.externalEscalationType = externalEscalationType;
        return this;
    };
    TicketEscalationBuilder.prototype.build = function () {
        return this.ticketEscalation;
    };
    return TicketEscalationBuilder;
}());
export { TicketEscalationBuilder };
//# sourceMappingURL=ticket-escalation.builder.js.map